﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederBsDto from '../Models/VeilederBsDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { satserReducer } from '../../Shared/Scripts/Store/Satser/Reducers';
import { valgReducer } from './Valg/Reducers';
import { Satser } from '../Utilities/BorteboerstipendApi';

const rootReducer = combineReducers<VeilederBsAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    satser: satserReducer,
    epiContext: (
        state: EpiContext<VeilederBsDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederBsDto>,
    ): EpiContext<VeilederBsDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
});

export type VeilederBsAppState = EpiAppStateMedSteg<VeilederBsDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: Satser | null;
};

export default function configureStore(): Store<VeilederBsAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
